/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import { PurchaseOrderLinesService } from '@control-tower/platform-orders';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFOrdersEntities,
} from '@pf/shared-common';
import { PurchaseOrderLineStore } from './purchase-order-line.store';
import {
    PurchaseOrderLineCreate,
    PurchaseOrderLineRead,
    PurchaseOrderLineSearchParams,
} from '../../entities/purchase-order-line.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class PurchaseOrderLineDataService extends AbstractDataService<
    PurchaseOrderLineRead,
    PurchaseOrderLineCreate
> {
    protected EntityName = PFOrdersEntities.PurchaseOrderLine;
    constructor(
        private service: PurchaseOrderLinesService,
        store: PurchaseOrderLineStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(
        body: PurchaseOrderLineCreate,
        purchaseOrderHeaderId?: string
    ): Observable<PurchaseOrderLineRead> {
        return this.service.purchaseOrderLineCreate({
            purchaseOrderHeaderId: purchaseOrderHeaderId as string,
            purchaseOrderLineViewModelCreateBody: body,
        }) as Observable<PurchaseOrderLineRead>;
    }
    protected deleteObs$(
        id: string,
        purchaseOrderHeaderId?: string
    ): Observable<PurchaseOrderLineRead> {
        return this.service.purchaseOrderLineDelete({
            id,
            purchaseOrderHeaderId: purchaseOrderHeaderId as string,
        }) as Observable<PurchaseOrderLineRead>;
    }
    protected undoDeleteObs$(
        id: string,
        purchaseOrderHeaderId?: string
    ): Observable<PurchaseOrderLineRead> {
        return this.service.purchaseOrderLineUndoDelete({
            id,
            purchaseOrderHeaderId: purchaseOrderHeaderId as string,
        }) as Observable<PurchaseOrderLineRead>;
    }
    protected getObs$(
        id: string,
        purchaseOrderHeaderId?: string
    ): Observable<PurchaseOrderLineRead> {
        return this.service.purchaseOrderLineReadById({
            id,
            purchaseOrderHeaderId: purchaseOrderHeaderId as string,
        }) as Observable<PurchaseOrderLineRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[],
        _: PurchaseOrderLineCreate,
        purchaseOrderHeaderId?: string
    ): Observable<PurchaseOrderLineRead> {
        return this.service.purchaseOrderLineUpdatePatch({
            id,
            purchaseOrderHeaderId: purchaseOrderHeaderId as string,
            operation: operations,
        }) as Observable<PurchaseOrderLineRead>;
    }
    protected searchObs$(
        searchParams: PurchaseOrderLineSearchParams
    ): Observable<IPagedResult<PurchaseOrderLineRead>> {
        return this.service.purchaseOrderLineSearch(searchParams) as Observable<
            IPagedResult<PurchaseOrderLineRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<
        IPagedResult<EntityChangeTrackingDto<PurchaseOrderLineRead>>
    > {
        const { parentId, ...params } = searchParams;
        return this.service.purchaseOrderLineGetChanges({
            ...params,
            purchaseOrderHeaderId: parentId as string,
        }) as Observable<
            IPagedResult<EntityChangeTrackingDto<PurchaseOrderLineRead>>
        >;
    }
}
